// @ts-nocheck
(function () {
  'use strict';

  const ZOOM_FACTOR = 2.5;
  const LENS_SIZE = 120;

  function buildUI(gallery) {
    if (gallery.dataset.hoverZoomInit) return;
    gallery.dataset.hoverZoomInit = '1';
    gallery.style.position = 'relative';

    const resultPanel = document.createElement('div');
    resultPanel.className = 'fab-zoom-result';
    resultPanel.setAttribute('aria-hidden', 'true');
    /* Append to body so it is never clipped by parent overflow or stacking contexts */
    document.body.appendChild(resultPanel);

    const lens = document.createElement('div');
    lens.className = 'fab-zoom-lens';

    let activeContainer = null;
    let activeImg = null;

    function onEnter(e) {
      const container = e.currentTarget;
      const img = container.querySelector('img.product-media__image');
      if (!img || !img.complete || !img.naturalWidth) return;

      activeContainer = container;
      activeImg = img;

      container.style.position = 'relative';
      container.appendChild(lens);

      const src = img.currentSrc || img.src;
      const galleryRect = gallery.getBoundingClientRect();

      resultPanel.style.backgroundImage = `url('${src}')`;
      resultPanel.style.backgroundSize =
        `${img.offsetWidth * ZOOM_FACTOR}px ${img.offsetHeight * ZOOM_FACTOR}px`;
      resultPanel.style.height = img.offsetHeight + 'px';
      /* Position fixed: to the right of the gallery, aligned to its top */
      resultPanel.style.top = galleryRect.top + 'px';
      resultPanel.style.left = (galleryRect.right + 20) + 'px';
      resultPanel.style.display = 'block';
      lens.style.display = 'block';
    }

    function onMove(e) {
      if (!activeContainer || !activeImg) return;

      const imgRect = activeImg.getBoundingClientRect();
      const containerRect = activeContainer.getBoundingClientRect();
      const half = LENS_SIZE / 2;

      let x = e.clientX - imgRect.left;
      let y = e.clientY - imgRect.top;
      x = Math.max(half, Math.min(imgRect.width - half, x));
      y = Math.max(half, Math.min(imgRect.height - half, y));

      lens.style.left = (e.clientX - containerRect.left - half) + 'px';
      lens.style.top = (e.clientY - containerRect.top - half) + 'px';

      /* Update panel vertical position to follow mouse vertically */
      const galleryRect = gallery.getBoundingClientRect();
      const panelHeight = resultPanel.offsetHeight;
      let panelTop = e.clientY - panelHeight / 2;
      panelTop = Math.max(galleryRect.top, Math.min(galleryRect.bottom - panelHeight, panelTop));
      resultPanel.style.top = panelTop + 'px';

      const bgX = -(x * ZOOM_FACTOR - resultPanel.offsetWidth / 2);
      const bgY = -(y * ZOOM_FACTOR - resultPanel.offsetHeight / 2);
      resultPanel.style.backgroundPosition = `${bgX}px ${bgY}px`;
    }

    function onLeave() {
      activeContainer = null;
      activeImg = null;
      resultPanel.style.display = 'none';
      lens.style.display = 'none';
      if (lens.parentNode) lens.parentNode.removeChild(lens);
    }

    function attach() {
      gallery
        .querySelectorAll('.product-media-container--image:not(.dialog-zoomed-gallery *)')
        .forEach((c) => {
          if (c.dataset.hoverZoomBound) return;
          c.dataset.hoverZoomBound = '1';
          c.addEventListener('mouseenter', onEnter);
          c.addEventListener('mousemove', onMove);
          c.addEventListener('mouseleave', onLeave);
        });
    }

    attach();
    // Watch for new image containers added inside the gallery (e.g. variant image swap)
    new MutationObserver(attach).observe(gallery, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(buildUI);
  }

  // Watch document for media-gallery elements being added/replaced (variant re-render)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;
        if (node.tagName === 'MEDIA-GALLERY') {
          buildUI(node);
        } else {
          node.querySelectorAll('media-gallery').forEach(buildUI);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
